import React from "react";
import {
  Image,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import fontBold from "../pdf/fonts/NotoSansTamil-Bold.ttf";
import fontRegular from "../pdf/fonts/NotoSansTamil-Regular.ttf";

Font.register({
  family: "NotoSansTamil",
  fonts: [
    { src: fontRegular, fontWeight: "normal" },
    { src: fontBold, fontWeight: "bold" },
  ],
});

// Create styles
const styles = StyleSheet.create({
  print: {
    fontWeight: "bold",
    fontSize: 16,
    textAlign: "right",
  },
  page: {
    padding: 10,
    fontSize: 10,
    fontFamily: "Helvetica",
    border: "2 solid black",
  },
  container: {
    padding: 10,
    marginTop: 10,
  },
  headerContainer: {
    borderBottom: "1 solid black",
    border: "1 solid black",
    padding: 0,
    marginBottom: 5,
  },
  headerTop: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  headerLeft: {
    width: "30%",
    paddingRight: 0,
    textAlign: "left",
    paddingLeft: 5,
    paddingTop: 5,
  },
  headerRight: {
    width: "40%",
    padding: 0,
    textAlign: "right",
    paddingRight: 5,
    paddingTop: 5,
  },
  headerImgLeft: {
    width: "10%",
    paddingRight: 0,
    marginBottom: 10,
  },
  headerImgRight: {
    width: "10%",
    padding: 0,
    marginRight: 8,
    marginBottom: 10,
  },
  headerCenter: {
    width: "80%",
    textAlign: "center",
    paddingBottom: 10,
  },
  centerContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    paddingBottom: 0,
    borderBottom: "1 solid black",
  },
  paddingBottom: {
    paddingBottom: 10,
    marginLeft: 2,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "left",
  },
  paddingBottomName: {
    paddingTop: 10,
    paddingBottom: 2,
    marginLeft: 2,
    fontSize: 13,
    fontWeight: "bold",
    textAlign: "left",
  },
  paddingBottomaddress: {
    paddingBottom: 2,
    paddingLeft: 0,
    fontSize: 13,
    fontWeight: "bold",
    textAlign: "left",
  },
  sectionRight: {
    width: "35%",
    textAlign: "left",
    borderLeft: "1px solid black",
  },
  marginLeft: {
    marginLeft: 2,
    marginBottom: 2,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "left",
  },
  image: {
    width: "60px",
    height: "70px",
  },
  invoiceSpace: {
    paddingLeft: 2,
    marginTop: 0,
    marginBottom: 0,
  },
  companyTitle: {
    fontSize: 30,
    fontWeight: "900",
    textAlign: "center",
    letterSpacing: 0,
    textTransform: "uppercase",
    color: "black",
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
  },
  taxWrapper: {
    backgroundColor: "black",
    alignSelf: "flex-start",
    paddingHorizontal: 5,
    marginLeft: 150,
  },
  companyTaxTitle: {
    fontSize: 13,
    fontWeight: "bold",
    textAlign: "center",
    color: "white",
  },
  companyMargin: {
    textAlign: "center",
    paddingTop: 5,
  },
  invoiceDetailsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  sectionLeft: {
    width: "65%",
  },
  marginBottom: {
    marginBottom: 10,
    marginTop: 20,
    marginLeft: 3,
  },
  bold: {
    fontSize: 13,
    fontWeight: "bold",
  },
  tableHeader: {
    flexDirection: "row",
    borderTop: "1 solid black",
    borderBottom: "1 solid black",
    backgroundColor: "#f0f0f0",
    paddingVertical: 0,
    width: "100%",
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1 solid black",
    height: 20,
  },
  tableCol: {
    display: "flex",
    width: "10%",
    borderRight: "1 solid black",
    textAlign: "center",
    alignItems: "center",
  },
  tableColl: {
    width: "10%",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingVertical: 8,
    fontSize: 10,
    fontWeight: "bold",
  },
  valueTableCol: {
    width: "20%",
    borderRight: "1 solid black",
    textAlign: "center",
  },
  tablePrice: {
    width: "20%",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingVertical: 8,
  },
  tableeRate: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    textAlign: "center",
    fontSize: 13,
    fontWeight: "bold",
  },
  tableeAmount: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    textAlign: "center",
    fontSize: 13,
    fontWeight: "bold",
  },
  tableRate: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    textAlign: "center",
  },
  tableAmount: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    textAlign: "center",
  },
  tableRsValue: {
    width: "70%",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingVertical: 10,
  },
  tablePsValue: {
    width: "30%",
    textAlign: "center",
    paddingVertical: 10,
  },
  tableRs: {
    width: "70%",
    textAlign: "center",
  },
  tablePs: {
    width: "30%",
    textAlign: "center",
  },
  tableColFirst: {
    width: "20%",
    borderLeft: "1 solid black",
    borderRight: "1 solid black",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
  },
  tableCollFirst: {
    width: "20%",
    borderLeft: "1 solid black",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingVertical: 8,
    fontSize: 13,
    fontWeight: "bold",
  },
  tableColLarge: {
    width: "30%",
    borderRight: "1 solid black",
    textAlign: "center",
  },
  tableCollLarge: {
    width: "30%",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingVertical: 8,
    fontSize: 13,
    fontWeight: "bold",
  },
  footerContainer: {
    marginTop: 5,
    paddingTop: 0,
    borderTop: "1 solid black",
    border: "1 solid black",
  },
  borderTop: {
    borderTop: "1 solid black",
    paddingVertical: 6,
  },
  footerLeft: {
    width: "60%",
    borderRight: "1 solid black",
    padding: 0,
  },
  footerRight: {
    width: "40%",
    padding: 0,
    display: "flex",
    flexDirection: "row",
  },
  firstFooterOne: {
    borderRight: "1 solid black",
    width: "60%",
    textAlign: "right",
  },
  firstFooterTwo: {
    paddingVertical: 7,
  },
  secondFooterOne: {
    width: "40%",
    textAlign: "center",
  },
  secondFooterTwo: {
    paddingVertical: 7,
  },
  footerSign: {
    marginBottom: 20,
    fontFamily: "Helvetica",
  },
  footerBottom: {
    flexDirection: "column",
    borderTop: "1 solid black",
    marginTop: 5,
    marginBottom: 5,
    justifyContent: "space-between",
    border: "1 solid black",
    padding: 5,
  },
  footerNote: {
    fontSize: 8,
    textAlign: "center",
  },
  topHead: {
    fontFamily: "NotoSansTamil",
    paddingRight: 10,
    fontSize: 15,
  },
  rowWithBorder: {
    flexDirection: "row",
    borderWidth: 1,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderColor: "#000",
    width: "40%",
  },
  columnBox: {
    flex: 1,
    flexDirection: "column",
  },
  verticalDivider: {
    width: 1,
    backgroundColor: "#000",
  },
  rowItem: {
    padding: 8,
    justifyContent: "center",
    alignItems: "flex-start",
  },
  rowSeparator: {
    borderTopWidth: 1,
    borderColor: "#000",
  },
  label: {
    fontSize: 13,
    fontWeight: "bold",
  },
  value: {
    fontSize: 13,
    fontWeight: "bold",
  },
});

// Helper function to split values into Rs and Ps
const splitIntoRsPs = (value) => {
  // Convert value to number, handle edge cases
  const numericValue = parseFloat(value);
  if (isNaN(numericValue) || value == null) return { rs: "", ps: "" };
  const [rs, ps] = numericValue.toFixed(2).split(".");
  return { rs, ps };
};

// Function to convert rupees to words
function convertRupeesToWordsWithBreaks(amount) {
  const numericAmount = parseFloat(amount);
  if (isNaN(numericAmount)) return "Zero Rupees";

  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const thousands = ["", "Thousand", "Lakh", "Crore"];

  function convertGroup(number, thousandIndex) {
    if (number === 0) return "";

    let str = "000" + number;
    str = str.slice(-3);

    const hundred = parseInt(str[0], 10);
    const ten = parseInt(str[1], 10);
    const one = parseInt(str[2], 10);

    let words = [];

    if (hundred > 0) {
      words.push(ones[hundred] + " Hundred");
    }

    if (ten === 1) {
      words.push(teens[one]);
    } else {
      if (ten > 0) {
        words.push(tens[ten]);
      }
      if (one > 0) {
        words.push(ones[one]);
      }
    }

    if (thousandIndex > 0 && words.length > 0) {
      words.push(thousands[thousandIndex]);
    }

    return words.join(" ");
  }

  function convertIntegerPart(integerPart) {
    const groups = [];
    let thousandIndex = 0;

    while (integerPart > 0) {
      const divisor = thousandIndex === 1 ? 100 : 1000;
      groups.push(convertGroup(integerPart % divisor, thousandIndex));
      integerPart = Math.floor(integerPart / divisor);
      thousandIndex++;
    }

    const resultGroups = groups.reverse().filter((group) => group !== "");
    const lastGroupIndex = resultGroups.length - 1;
    const formattedGroups = resultGroups.map((group, index) =>
      index === lastGroupIndex ? `${group}` : group
    );

    return formattedGroups.join(" ");
  }

  function convertDecimalPart(decimalPart) {
    if (decimalPart === 0) {
      return "";
    }

    let paise = Math.round(decimalPart * 100);
    return `${convertGroup(paise, 0)} Paise`;
  }

  const integerPart = Math.floor(numericAmount);
  const decimalPart = numericAmount - integerPart;

  const integerWords = convertIntegerPart(integerPart);
  const decimalWords = convertDecimalPart(decimalPart);

  const result =
    integerWords + " Rupees" + (decimalWords ? "\nAnd " + decimalWords : "");
  return result.trim();
}

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const currentYear = date.getFullYear().toString();
  return `${day}/${month}/${currentYear}`;
};

// Create Document Component
const SalesTaxPDF = ({ data, type }) => {
  // Ensure data.product is an array
  const products = Array.isArray(data.product) ? data.product : [];
  const words = convertRupeesToWordsWithBreaks(data.total || 0);

  // Calculate tax amounts with fallbacks
  let totalCGST = 0;
  let totalSGST = 0;
  let totalIGST = 0;

  products.forEach((product) => {
    if (product.tax_type === "GST") {
      const halfTax = parseFloat(product.tax_amt || 0) / 2;
      totalCGST += isNaN(halfTax) ? 0 : halfTax;
      totalSGST += isNaN(halfTax) ? 0 : halfTax;
    } else {
      const taxAmt = parseFloat(product.tax_amt || 0);
      totalIGST += isNaN(taxAmt) ? 0 : taxAmt;
    }
  });

  const IGST = products
    .filter((p) => p.tax_type === "IGST")
    .reduce((acc, product) => acc + parseFloat(product.tax_amt || 0), 0);

  const SGST = products
    .filter((p) => p.tax_type === "GST")
    .reduce((acc, product) => acc + parseFloat((product.tax_amt || 0) / 2), 0);

  const CGST = products
    .filter((p) => p.tax_type === "GST")
    .reduce((acc, product) => acc + parseFloat((product.tax_amt || 0) / 2), 0);

  const rowsPerPage =
    products.length >= 8 ? (products.length >= 10 ? 10 : 12) : 13;
  const productChunks = [];

  for (let i = 0; i < products.length; i += rowsPerPage) {
    productChunks.push(products.slice(i, i + rowsPerPage));
  }

  return (
    <Document>
      {productChunks.map((productChunk, pageIndex) => (
        <Page size="A4" style={styles.page} key={pageIndex}>
          <View style={styles.container}>
            {/* Header */}
            <Text style={styles.print}>[{type}]</Text>
            <View style={styles.headerContainer}>
              <View style={styles.headerTop}>
                <View style={styles.headerLeft}>
                  <Text>GST: 33EGBPS7610K1Z8</Text>
                </View>
                <View style={styles.headerRight}>
                  <Text style={styles.invoiceSpace}>L No : 53/2022</Text>
                </View>
              </View>
              <View style={styles.centerContainer}>
                <View style={styles.headerImgLeft}>
                  {/* <Image
                    src="https://t4.ftcdn.net/jpg/01/25/63/07/360_F_125630792_Y7FBQO4f779brbK3kw87iIihK7GE0aAO.jpg"
                    style={styles.image}
                  /> */}
                </View>
                <View style={styles.headerCenter}>
                  <Text style={styles.topHead}>TAX INVOICE</Text>
                  <View style={styles.taxWrapper}>
                    <Text style={styles.companyTaxTitle}>CASH/CREDIT BILL</Text>
                  </View>
                  <Text style={styles.companyTitle}>S.K FANCY CRACKERS</Text>
                  <Text style={styles.companyMargin}>
                    No:1/21,PATCHAYAPURAM,THAYILPATTI,SIVAKASI - 626 128.
                  </Text>
                </View>
                <View style={styles.headerImgRight}>
                  {/* <Image
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHSN-BemaprtWLPemWtPu1eaqXRnIjBlhsxWbbTNFjc6TEQTOCZAnVoKaVpNwImW3qWsc&usqp=CAU"
                    style={styles.image}
                  /> */}
                </View>
              </View>
              <View style={styles.invoiceDetailsContainer}>
                <View style={styles.sectionLeft}>
                  <Text style={styles.paddingBottomName}>
                    M/s. :{" "}
                    {data.party_name || "___________________________________"}
                  </Text>
                  <Text style={styles.paddingBottomaddress}>
                    Address :{" "}
                    {data.address || "___________________________________"}
                  </Text>
                  <Text style={styles.marginLeft}>
                    Buyer's GST No:{" "}
                    {data.gst_no || "_____________________________"}
                  </Text>
                </View>
                <View style={styles.rowWithBorder}>
                  <View style={styles.columnBox}>
                    <View style={styles.rowItem}>
                      <Text style={styles.label}>Tax Invoice No:</Text>
                    </View>
                    <View style={styles.rowSeparator} />
                    <View style={styles.rowItem}>
                      <Text style={styles.label}>Date:</Text>
                    </View>
                  </View>
                  <View style={styles.verticalDivider} />
                  <View style={styles.columnBox}>
                    <View style={styles.rowItem}>
                      <Text style={styles.value}>{data.bill_no || ""}</Text>
                    </View>
                    <View style={styles.rowSeparator} />
                    <View style={styles.rowItem}>
                      <Text style={styles.value}>
                        {formatDate(data.bill_date || "")}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
            {/* Table Header */}
            <View style={styles.tableHeader}>
              <Text style={styles.tableCollFirst}>S. No.</Text>
              <Text style={styles.tableCollLarge}>Particulars</Text>
              <Text style={styles.tableColl}>Qty</Text>
              <Text style={styles.tablePrice}>Rate</Text>
              <Text style={styles.tablePrice}>Amount</Text>
            </View>
            {/* Table Rows */}
            {Array.from({ length: rowsPerPage }).map((_, index) => {
              const product = productChunk[index];
              const qty = product ? parseFloat(product.qty || 0) : "";
              const priceUnit = product
                ? parseFloat(product.price_unit || 0)
                : "";
              const amount = product ? qty * priceUnit : "";
              const perRateSplit = product
                ? splitIntoRsPs(priceUnit)
                : { rs: "", ps: "" };
              const amountSplit = product
                ? splitIntoRsPs(amount)
                : { rs: "", ps: "" };

              // Calculate the serial number based on pageIndex and index
              const serialNumber = pageIndex * rowsPerPage + index + 1;

              return (
                <View style={styles.tableRow} key={index}>
                  <Text style={styles.tableColFirst}>
                    {product ? serialNumber : ""}
                  </Text>
                  <Text style={styles.tableColLarge}>
                    {product?.product_name || ""}
                  </Text>
                  <Text style={styles.tableCol}>{qty}</Text>
                  <Text style={styles.valueTableCol}>
                    {product ? `${perRateSplit.rs}.${perRateSplit.ps}` : ""}
                  </Text>
                  <Text style={styles.valueTableCol}>
                    {product ? `${amountSplit.rs}.${amountSplit.ps}` : ""}
                  </Text>
                </View>
              );
            })}

            {/* Footer - Only on the last page */}
            {pageIndex === productChunks.length - 1 && (
              <>
                <View style={styles.footerContainer}>
                  <View style={{ flexDirection: "row" }}>
                    <View style={styles.footerLeft}>
                      <Text style={styles.marginBottom}>
                        Despatched by:{" "}
                        {data.despatched_by || "___________________"} Cases No:{" "}
                        {data.cases_no || "_____________"}
                      </Text>
                      <Text style={styles.marginBottom}>
                        Through:{" "}
                        {data.through ||
                          "______________________________________"}
                      </Text>
                      <Text style={styles.marginBottom}>
                        From : {data.lr_bill_no || "______________________"} To
                        :{data.lr_bill_no || "________________________"}
                      </Text>
                      <Text style={styles.marginBottom}>
                        Weight Kgs : {data.weight_kgs || "________________"}{" "}
                        Freight : {data.freight || "________________"} Paid/To
                        Pay
                      </Text>
                      <Text style={styles.marginBottom}>
                        LR Number : {data.lr_bill_no || "____________________"}{" "}
                        Invoice No: {data.invoice_no || "_____________________"}
                      </Text>
                    </View>
                    <View style={styles.footerRight}>
                      <View style={styles.firstFooterOne}>
                        <Text style={styles.firstFooterTwo}>Sub Total </Text>
                        <Text style={styles.firstFooterTwo}>
                          Add Packing Charges 3%{" "}
                        </Text>
                        <Text style={styles.firstFooterTwo}>TOTAL Rs.</Text>
                        <Text style={styles.firstFooterTwo}>
                          Discount {data.discount} % Rs.
                        </Text>
                        <Text style={styles.firstFooterTwo}>
                          CGST{" "}
                          {data.overall_tax_percentage?.startsWith("GST@")
                            ? (parseFloat(
                                data.overall_tax_percentage.replace("GST@", "")
                              ) || 0) / 2
                            : products[0]?.tax_percentage / 2 || 0}{" "}
                          % Rs.
                        </Text>
                        <Text style={styles.firstFooterTwo}>
                          SGST{" "}
                          {data.overall_tax_percentage?.startsWith("GST@")
                            ? (parseFloat(
                                data.overall_tax_percentage.replace("GST@", "")
                              ) || 0) / 2
                            : products[0]?.tax_percentage / 2 || 0}{" "}
                          % Rs.
                        </Text>
                        <Text style={styles.firstFooterTwo}>
                          IGST{" "}
                          {data.overall_tax_percentage?.startsWith("IGST@")
                            ? parseFloat(
                                data.overall_tax_percentage.replace("IGST@", "")
                              ) || 0
                            : products[0]?.tax_percentage || 0}{" "}
                          % Rs.
                        </Text>
                        <Text style={styles.firstFooterTwo}>
                          {parseFloat(data.round_off || 0) !== 0
                            ? "R.O.A."
                            : ""}
                        </Text>
                        <Text style={styles.firstFooterTwo}>TOTAL Rs.</Text>
                      </View>
                      <View style={styles.secondFooterOne}>
                        <Text style={styles.secondFooterTwo}>
                          {parseFloat(data.sub_total)}
                        </Text>
                        <Text style={styles.secondFooterTwo}>
                          {splitIntoRsPs(parseFloat(0)).ps}
                        </Text>
                        <Text
                          style={[styles.secondFooterTwo, styles.borderTop]}
                        >
                          {parseFloat(data.sub_total)}
                        </Text>
                        <Text style={styles.secondFooterTwo}>
                          {parseFloat(data.overall_discount_amount)}
                        </Text>
                        <Text style={styles.secondFooterTwo}>
                          {data.overall_tax_percentage?.startsWith("GST@")
                            ? (
                                parseFloat(data.overall_tax_amount || 0) / 2
                              ).toFixed(2)
                            : 0}
                        </Text>
                        <Text style={styles.secondFooterTwo}>
                          {data.overall_tax_percentage?.startsWith("GST@")
                            ? (
                                parseFloat(data.overall_tax_amount || 0) / 2
                              ).toFixed(2)
                            : 0}
                        </Text>
                        <Text style={styles.secondFooterTwo}>
                          {data.overall_tax_percentage?.startsWith("IGST@")
                            ? parseFloat(data.overall_tax_amount || 0).toFixed(
                                2
                              )
                            : 0}
                        </Text>
                        <Text style={styles.secondFooterTwo}>
                          {parseFloat(data.round_off || 0) !== 0
                            ? parseFloat(data.round_off || 0)
                            : ""}
                        </Text>
                        <Text
                          style={[styles.secondFooterTwo, styles.borderTop]}
                        >
                          {parseFloat(data.total || 0)}
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
                <View style={styles.footerBottom}>
                  <View style={styles.headerTop}>
                    <Text>Rupees: {words} Only</Text>
                    <Text style={styles.footerSign}>
                      For S.K FANCY CRACKERS
                    </Text>
                  </View>
                  <View style={styles.headerTop}>
                    <Text>E.& 0.E.</Text>
                    <Text>Partner/Manager</Text>
                  </View>
                </View>
                <View style={styles.footerNote}>
                  <Text>Thank you</Text>
                </View>
              </>
            )}
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default SalesTaxPDF;
